
namespace Gordic.Vyp.AppSettings {

    export function VypPrintSettingsForm ():Forms.Form{
        
        let form = new Gordic.Forms

            .Form({ name: "VypPrintSettingsForm", tabOptions: { title: "jres:23900174", opened: false } } as any) //RC 23900174 : Tisk
            .addRow("").addField("gcheck", {
                name: "TiskPodArch",
                label: "jres:23900176", //RC 23900176 : Implicitně tisknout podací arch (výpravní protokol)
                model: "Global.Vyp.AppSettings.PrintSettings.TiskPodArch=value",
                initialValue: true 
            })
            ;

        return form;
        }
    }